module.exports = __webpack_public_path__ + "img/yellow-circle.03aef341.png";